import React from 'react'
import { useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { Link, Text } from '@contrast-security-inc/design-system-typography'
import { InformationPanel } from '@contrast-security-inc/design-system-surfaces'
import { IconNegativeResults } from '@contrast-security-inc/design-system-foundations'
import { Stack } from '@contrast-security-inc/design-system-layouts'
import { formatStyles } from '../../../../components/react-intl-helpers'

export const LibraryUsageGridEmptyState = () => {
  const intl = useIntl()

  return (
    <Stack>
      <InformationPanel
        data-e2e="library-usage-grid-empty-state-panel"
        className={css`
          width: 100%;
          height: fit-content;
        `}
        Icon={IconNegativeResults}
        IconProps={{
          testId: 'library-usage-grid-thumbs-down-icon'
        }}
        title={intl.formatMessage({
          id: 'title_libraryUsage_noDetailsFound'
        })}
        subtitle={intl.formatMessage({
          id: 'description_libraryUsage_unableToDetectUsageDetails'
        })}
        detail={intl.formatMessage({
          id: 'description_libraryUsage_oldAgentRunning'
        })}
      >
        <Text font="body" color="neutral70">
          {intl.formatMessage(
            { id: 'variable_libraryUsage_tryUpgradingAgent' },
            {
              a: (...msg) => (
                <Link
                  href={intl.formatMessage({ id: 'link_upgradeAgents' })}
                  isExternal={true}
                >
                  {msg}
                </Link>
              ),
              ...formatStyles.bold
            }
          )}
        </Text>
      </InformationPanel>
    </Stack>
  )
}
